<script lang="ts" setup>
  import type { SubmenuRootItem } from '~/types/submenu'

  defineProps<{
    item: SubmenuRootItem
  }>()
</script>

<template>
  <div v-if="item.emptyState" class="p-6 flex flex-col items-center gap-4">
    <p class="text-xs+ text-center text-[#9fa5aa]">{{ $t(item.emptyState.text || '') }}</p>
    <Button v-if="false" size="xs" variant="outline" @click="item.emptyState.handleAction(item)">
      <p class="text-xs+ text-[#9fa5aa]">{{ $t(item.emptyState.buttonText || '') }}</p>
    </Button>
  </div>
</template>

<style scoped></style>
